import { useApiWithAuth } from "@/modules/api";
import { FilaRntrc } from "./rntrcTypes";

/** Painel root das filas do RNTRC (SOL = solicitação, MON = monitoramento do pagamento). */
const useRntrcFilaService = () => {
  const { data, loading, get, post, del } = useApiWithAuth();

  const listar = (): Promise<void> => {
    return get("/root/rntrc/fila");
  };

  const reprocessar = (fila: FilaRntrc, idFila: number): Promise<void> => {
    return post(`/root/rntrc/fila/${fila}/${idFila}/reprocessar`);
  };

  const remover = (fila: FilaRntrc, idFila: number): Promise<void> => {
    return del(`/root/rntrc/fila/${fila}/${idFila}`);
  };

  const getNomeFila = (fila?: FilaRntrc | string | null) => {
    if (fila === "SOL") {
      return "Solicitação";
    } else if (fila === "MON") {
      return "Monitoramento do pagamento";
    }
    return fila ?? "";
  };

  return {
    data,
    loading,
    listar,
    reprocessar,
    remover,
    getNomeFila
  };
};

export { useRntrcFilaService };
